import axios from 'axios';
import { retryFailedApi } from './helpers';

export const siaProtocol = async (container) => {
  const { scac, requestDetails } = container;

  retryFailedApi();
  return await axios({
    method: 'post',
    url: `${process.env.VUE_APP_DOMAIN}/api/v1/turns/create/sia`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      container,
      requestDetails,
      scac,
    },
  });
};
